import { getFunctions, httpsCallable } from "firebase/functions";
import { validatePhoneNumber } from "tools";

export default async function createProvisionalUsers(provisionalUsers: ContactData[]) {

    const validatedProvisionalUsers = provisionalUsers.filter(contact => validatePhoneNumber(contact.id));
    const createProvisionalUsers = httpsCallable(getFunctions(), 'createProvisionalUsers');
    createProvisionalUsers({contactData: validatedProvisionalUsers});
}
